import Audit from 'views/components/Validation/Summary/Audit/Audit';

export default Audit;
